import { render } from "./Gallery.vue?vue&type=template&id=e04e720e"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"
script.render = render

export default script